import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function () {
    'use strict';

    angular.module('app').component('ratingpage', {
        template: require('./rating-page.html'),
        controller: RatingPageCtrl,
        controllerAs: 'vm'
    });

    RatingPageCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function RatingPageCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;

        vm.rating_types = [
            { name: 'Pronunciation',             key:'pronunciation', subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Punctuality',               key:'punctuality',   subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Mastery of Subject Matter', key:'smartness',     subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Teaching Method',           key:'faith',         subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Feedback Quality',          key:'helpfulness',   subtitle: 'How good is the teacher in lorem ipsum'},
        ];
        vm.id = $stateParams.id;

        vm.back = () => {
            window.history.back();
        }

        vm.get_data = function(){
            
            var request = {
                method: 'GET',
                route: URLS.base + `/regular_class_item/${vm.id}/regular_class`,
            };

            
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.submitted = true;
                        vm.item = response.data.data.data[0];
                        // console.log(response.data.data.data[0].id);
                        if(!vm.item){
                            vm.id = null;

                        }

                        console.log(vm.item);

                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.get_data();


        vm.save = () => {

            const data = {
                regular_class_id: vm.id,
                review: vm.review,
            }

            vm.rating_types.forEach((rt) => {
                data[rt.key] = ''+rt.value
            });

            var request = {
                method: 'POST',
                route: URLS.base + `/rating`,
                body: data
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.has_rating = true;
                        vm.get_data();
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }
    }

})();



// WEBPACK FOOTER //
// ./src/app/components/rating-page/rating-page.component.js